import { flux } from '@/core/flux.module';
import { LIMIT_SIZE_1000 } from '@/main/app.constants';
import { SortByEnum, sqConditionMonitorsApi } from '@/sdk/api/ConditionMonitorsApi';
import { isConditionMonitorNotificationsEnabled } from '@/services/systemConfiguration.utilities';
import { logError } from '@/utilities/logger';
import _ from 'lodash';
import { isPresentationWorkbookMode } from '@/utilities/utilities';
import { isCanceled } from '@/utilities/http.utilities';
import { PUSH_IGNORE } from '@/core/flux.service';

export async function fetchMonitoredConditionIds(conditionIds: string[]): Promise<void> {
  if (!isConditionMonitorNotificationsEnabled() || isPresentationWorkbookMode() || _.isEmpty(conditionIds)) {
    return;
  }

  try {
    const {
      data: { conditionMonitorMetadataList },
    } = await sqConditionMonitorsApi.getConditionMonitorMetadataList({
      conditionIds,
      sortBy: SortByEnum.Name,
      limit: LIMIT_SIZE_1000,
    });

    flux.dispatch('TREND_SET_MONITORED_CONDITION_IDS', { conditionIds, conditionMonitorMetadataList }, PUSH_IGNORE);
  } catch (e) {
    if (!isCanceled(e)) {
      logError(_.toString(e));
    }
  }
}
